const ADVANCED_FILTERS = {
  MIN_LOCAL_BALANCE: -100000000,
  MAX_LOCAL_BALANCE: 100000000,
};

Object.freeze(ADVANCED_FILTERS);

export default ADVANCED_FILTERS;
